import { AuthenticationForm } from '@dtx-company/inter-app/src/components/Authentication/AuthenticationForm'
import { BackButton } from '../../BackButton/BackButton'
import { CodeConfigurationField } from '@dtx-company/inter-app/src/types/flowcode'
import { FC, useCallback } from 'react'
import { LoggedOutGeneratorSection } from '@app/code/src/components/LoggedOutCodeGeneratorV2/LoggedOutCodeGenerator.types'
import { Stack } from '@dtx-company/design-system/src'
import {
  selectError,
  selectScanDestinationIsValid
} from '@app/code/src/machines/locg/locgSelectors'
import { useGlobalServices } from '@app/common/src/hooks/useGlobalServices'
import { useSelector } from '@xstate/react'

export const AuthSection: FC<{ hideBackButton?: boolean; onSubmitError?: () => void }> = ({
  hideBackButton,
  onSubmitError
}) => {
  const { locgService } = useGlobalServices()

  const error = useSelector(locgService, selectError)(CodeConfigurationField.SCAN_DESTINATION)

  const scanDestinationIsNotEmpty = useSelector(locgService, selectScanDestinationIsValid)

  const onFocus = useCallback((): boolean => {
    locgService.send({ type: 'BLUR', target: LoggedOutGeneratorSection.ScanDestination })
    const formIsValid = !error && scanDestinationIsNotEmpty
    if (formIsValid) {
      locgService.send({ type: 'NEXT', target: LoggedOutGeneratorSection.ScanDestination })
    }
    return formIsValid
  }, [error, locgService, scanDestinationIsNotEmpty])

  return (
    <>
      {!hideBackButton && <BackButton />}
      <Stack
        sx={theme => ({
          pt: 2,
          maxWidth: {
            md: hideBackButton ? 'auto' : theme.spacing(136)
          },
          width: '100%'
        })}
      >
        <AuthenticationForm
          action="sign up"
          product="flowcode"
          validateOnFormFocus={onFocus}
          onSubmitError={onSubmitError}
        />
      </Stack>
    </>
  )
}
